import { Record } from "immutable";

class UserRecord extends Record({
    first_name: null,
    last_name: null,
    email: null,
    phone_no: null,
    roles: [],
    is_active: []
}) {

}

export default UserRecord;